import { cn } from "@theprelude/core";
import { useId } from "react";

export const M365Icon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M20.7256 4.58277L14.1759 0.62018C13.4008 0.150782 12.5166 -0.0457099 11.6433 0.00887126C10.71 0.565599 9.86397 1.34611 9.30179 2.19212C8.6359 3.19095 8.62498 4.72468 8.62498 4.74105V8.88376L9.65657 8.26154C11.0484 7.42099 12.7895 7.42099 14.1759 8.26154L16.2827 9.53328L20.3545 12.0113C20.42 12.0495 21.9537 12.9937 22.6032 14.3801C22.6905 14.5657 22.7615 14.7676 22.8324 14.9696V8.31612C22.8324 6.78785 22.0356 5.36874 20.7256 4.57731V4.58277ZM7.41328 18.3754L10.8737 16.1867L9.65657 15.4499C8.35208 14.6584 7.54973 13.2448 7.54973 11.7165V9.53873L7.56611 9.52782H7.53882V4.74105C7.53882 4.66464 7.54973 2.86346 8.39574 1.58627C8.47761 1.46619 8.55948 1.34611 8.64681 1.23149L3.10683 4.58277C1.79688 5.37419 1 6.7933 1 8.32158V15.6791C1 16.7107 1.37115 17.6822 2.00429 18.4518C2.92126 18.883 3.94738 19.145 4.89163 19.1668C6.09242 19.1941 7.39691 18.3863 7.40782 18.3754H7.41328ZM19.7868 12.9446L16.2827 10.8159V11.7111C16.2827 13.2393 15.4858 14.653 14.1759 15.4444L11.9708 16.7816L7.99184 19.2924C7.92634 19.3306 6.40353 20.2858 4.8698 20.253C4.73881 20.253 4.60235 20.2421 4.4659 20.2312L9.65657 23.3696C11.0484 24.2101 12.7895 24.2101 14.1813 23.3696L20.7311 19.407C21.3806 19.014 21.9046 18.4627 22.2648 17.8187C22.2484 16.7816 22.0246 15.7173 21.6153 14.844C21.1077 13.7579 19.7977 12.9501 19.7868 12.9446Z" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.213257)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
